import App from './Portal';
export default App;